import { MarkType, NodeType } from 'prosemirror-model'
import { Plugin, PluginKey } from 'prosemirror-state'

import { getAttributes } from '@tiptap/core'
import { disableVideoAutoplay } from '../../utils'

type ClickHandlerOptions = {
  type: MarkType | NodeType
}

export function clickHandler(
  options: ClickHandlerOptions,
  type: string
): Plugin {
  return new Plugin({
    key: new PluginKey('handleClickLink'),
    props: {
      handleClick: (view, _pos, event) => {
        const attrs = getAttributes(view.state, options.type.name)
        const element = (event.target as HTMLElement)?.closest(type)

        if (type === 'video') {
          disableVideoAutoplay()
        }

        if (element && attrs) {
          return false
        }

        return false
      },
    },
  })
}
